import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import moment from 'moment';

import {
  isUserAgentIphoneApp,
} from 'common/util/isUserAgentMobileApp';

import {
  getDataTableSettingsFromProps as getDataTableMarketingPartnerListingsSettings,
} from 'client/components/SrDataTableMarketingPartnerListings';

import {
  dataTable,
} from 'client/helpers/dataTables';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrIcon from 'client/components/SrIcon';
import SrPartnerInstallMobileAppBanner from 'client/components/SrPartnerInstallMobileAppBanner/SrPartnerInstallMobileAppBanner';
import SrPartnerOverviewStats from 'client/components/SrPartnerOverviewStats';
import SrPartnerStatsDatePicker from 'client/components/SrPartnerStatsDatePicker';

import branch from 'client/core/branch';
import PartnerActions from 'client/actions/Partner';
import { sunRiseEnabled, tenantScreeningEnabled } from 'common/partnerHelpers';
import { PARTNER_TYPE_AGENT } from 'common/partnerConstants';

function getMonths(partner) {
  const partnerCreatedDate = moment(partner.createdDate).startOf('month');

  const nowDate = moment();
  const diffMonths = nowDate.diff(partnerCreatedDate, 'months');
  const months = [];

  for (let index = 0; index <= diffMonths; index += 1) {
    const monthMoment = partnerCreatedDate.clone().add(index, 'months');
    months.push({
      title: monthMoment.format('MMM YYYY'),
      value: monthMoment.startOf('month').toISOString(),
    });
  }

  return months.reverse();
}

@dataTable((props) => getDataTableMarketingPartnerListingsSettings({
  ...props,
  itemsPropName: 'marketingPartnerListings',
}))
@branch({
  userAgent: ['analytics', 'userAgent'],
})
class SrPartnerOverviewPageHeader extends Component {
  static propTypes = {
    marketingPartnerListings: PropTypes.array.isRequired,
    userAgent: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    const months = getMonths(props.partner);

    this.state = {
      months,
      startDate: months[0].value,
    };
  }

  componentDidMount() {
    const { dispatch, partner } = this.props;
    const { startDate } = this.state;

    const endDate = moment(startDate)
      .endOf('month')
      .toISOString();

    dispatch(PartnerActions.getOverviewStats, {
      partnerId: partner.id,
      startDate: startDate,
      endDate: endDate,
    });
  }

  _onChangeMonth = (startDate) => {
    const { dispatch, partner } = this.props;
    this.setState({ startDate });

    const endDate = moment(startDate)
      .endOf('month')
      .toISOString();

    dispatch(PartnerActions.getOverviewStats, {
      partnerId: partner.id,
      startDate: startDate,
      endDate: endDate,
    });
  }

  _onClickGoToMarketingPartnerListingSection = () => {
    const element = global.document.querySelector('.SrDataTableMarketingPartnerListings');
    element.scrollIntoView({ behavior: 'smooth' });
  }

  _shouldDisplayStats = (partner) => {
    if (!partner || partner.type === PARTNER_TYPE_AGENT || sunRiseEnabled(partner)) {
      return false;
    }

    return !tenantScreeningEnabled(partner);
  }

  render() {
    const {
      partner,
      marketingPartnerListings,
      currentUser,
      userAgent,
    } = this.props;
    const {
      months,
      startDate,
    } = this.state;

    const isSunriseEnabled = sunRiseEnabled(partner);
    const marketingPartnerListingsNotReady = marketingPartnerListings
      .filter(({ walkthroughIssuesResolved }) => walkthroughIssuesResolved === false);

    const showMobileAppBanner = !(currentUser.partnerAppInstalled || isUserAgentIphoneApp(userAgent));
    const shouldDisplayStats = this._shouldDisplayStats(partner);

    return (
      <div className='SrPartnerOverviewPageHeader'>
        {showMobileAppBanner && (
          <SrBox margin='5px 16px 16px'>
            <SrPartnerInstallMobileAppBanner />
          </SrBox>
        )}
        {marketingPartnerListingsNotReady.length > 0 && !isSunriseEnabled && (
          <SrFlex
            className='listingNotReadyCard'
            bgColor='red200'
          >
            <SrIcon className='warning-icon' marginRight={18} marginTop={6} />
            <SrBox>
              <SrText
                size='larger'
                weight='800'
                color='red'
                font='greycliff'
                letterSpacing='0'
              >
                You have {
                  pluralize('property', marketingPartnerListingsNotReady.length, true)
                } not ready to be listed
              </SrText>
              <SrText
                display='block'
                weight='medium'
                font='greycliff'
                letterSpacing='0'
              >
                <SrText
                  cursor='pointer'
                  decoration='underline'
                  weight='inherit'
                  color='blue300'
                  font='greycliff'
                  onClick={this._onClickGoToMarketingPartnerListingSection}
                >
                  View the properties below
                </SrText>
                {' to see the reasons why they cannot be listed right now.'}
              </SrText>
            </SrBox>
          </SrFlex>
        )}

        <div className='welcomeBox'>
          {shouldDisplayStats &&
            <SrPartnerStatsDatePicker
              partner={partner}
              months={months}
              selectedMonthValue={startDate}
              onChange={this._onChangeMonth}
            />
          }
        </div>
        {shouldDisplayStats &&
          <SrPartnerOverviewStats
            partner={partner}
          />
        }
      </div>
    );
  }
}

SrPartnerOverviewPageHeader.displayName = 'SrPartnerOverviewPageHeader';

export default SrPartnerOverviewPageHeader;
